import svg from 'src/images/custom-icons/vendors.icon.svg';

const vendorsSideBarTokens = {
    iconData: svg,
    iconWidth: 20,
    iconHeight: 20,
    iconTitle: 'Vendors'
};

export default vendorsSideBarTokens;
